import { useState } from 'react';
import { EmojiSmile } from 'react-bootstrap-icons';
import { Navigate, useParams } from 'react-router-dom';

import { Button, Typography, Space, Divider, Radio, Form, Spin } from 'antd';

import { validate } from 'uuid';

import EmptyState from '@/components/shared/EmptyState';
import Wrapper from '@/components/shared/Wrapper';
import { saveUnsubscribeFeedback } from '@/services/notifications';
import styled, { StyledProp, css } from '@/styled';

const Unsubscribe = ({ className }: StyledProp) => {
  const { trackId } = useParams<{ trackId: string }>();
  const [saved, setSaved] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = ({ reason }: { reason: string }) => {
    setIsLoading(true);
    saveUnsubscribeFeedback({
      reason,
      trackId: trackId ?? ''
    })
      .then(() => {
        setSaved(true);
        setIsLoading(false);
      })
      .catch(() => {
        setIsLoading(false);
      });
  };

  const reasons = [
    'Não quero mais receber estes e-mails.',
    'Eu nunca me inscrevi para essa lista de e-mails.',
    'O assunto não é do meu interesse.',
    'Estou recebendo muitos e-mails dessa lista.',
    'Outro motivo.'
  ];

  if (!validate(trackId ?? '')) {
    return <Navigate to='/notificacoes' />;
  }

  if (saved) {
    return (
      <EmptyState
        icon={<EmojiSmile />}
        title='Obrigado pelo seu feedback'
        description='Seu feedback é muito importante para melhorarmos cada vez mais sua experiência'
      />
    );
  }

  return (
    <Wrapper className={className}>
      <Spin spinning={isLoading} size='large'>
        <Form onFinish={handleSave}>
          <div className='unsubscribe-container'>
            <Typography.Title className='title' level={2} ellipsis={true}>
              Descadastramento de notificações por e-mail
            </Typography.Title>
            <Typography>Por que você está descadastrando da lista de e-mails?</Typography>
            <br />
            <Form.Item name='reason' rules={[{ required: true, message: 'Selecione uma opção' }]}>
              <Radio.Group className='unsubscribe-radioGroup '>
                {reasons.map((item, key) => (
                  <div key={key}>
                    <div className='unsubscribe-items'>
                      <div className='unsubscribe-itemRadio'>
                        <Space>
                          <Radio value={item}>
                            <Typography.Text strong>{item}</Typography.Text>
                          </Radio>
                        </Space>
                      </div>
                    </div>
                    <Divider className='unsubscribe-divider' />
                  </div>
                ))}
              </Radio.Group>
            </Form.Item>
            <Typography className='unsubscribe-disclaimer'>
              Para voltar para a lista você precisa acessar configurações de notificações no Nutror e habilitar o envio
              de e-mails.
            </Typography>
            <div className='unsubscribe-footer'>
              <Button className='unsubscribe-btnSave' htmlType='submit' type='primary' size='large'>
                Enviar resposta
              </Button>
            </div>
          </div>
        </Form>
      </Spin>
    </Wrapper>
  );
};
export default styled(Unsubscribe)(
  ({ theme }) => css`
    .unsubscribe-container {
      margin-top: ${theme.space.spacing(12)};
      padding-left: 13vw;
      margin-right: 13vw;

      ${theme.breakpoints.down('md')} {
        padding-left: ${theme.space.spacing(4)};
        margin-right: ${theme.space.spacing(4)};
      }
    }

    .unsubscribe-footer {
      display: flex;
      flex-direction: row-reverse;
      margin-top: ${theme.space.spacing(8)};
      gap: ${theme.space.spacing(8)};
      padding-bottom: ${theme.space.spacing(12)};
      align-items: left;

      ${theme.breakpoints.down('md')} {
        flex-direction: column;
      }
    }

    .unsubscribe-btnSave {
      ${theme.breakpoints.down('md')} {
        width: 100%;
      }
    }

    .unsubscribe-items {
      display: flex;
      gap: ${theme.space.spacing(4)};
      align-items: left;
      justify-content: left;
      flex-direction: row;
      padding: ${theme.space.spacing(4, 0)};

      ${theme.breakpoints.down('md')} {
        display: block;
      }
    }
    .unsubscribe-radioGroup {
      width: 100%;
    }

    .unsubscribe-itemRadio {
      display: flex;
      flex-direction: row;
      gap: ${theme.space.spacing(8)};
      align-items: left;
      padding-right: 10px;

      ${theme.breakpoints.down('md')} {
        padding-top: ${theme.space.spacing(4)};
      }
    }

    .unsubscribe-divider {
      margin: 0;
      border-color: ${theme.colorTextQuaternary};
    }
  `
);
